module.exports = __webpack_public_path__ + "img/logo_western_union2.490edcff.png";